const baseDomain = process.env.REACT_APP_SERVER;
const auth = "/api/auth";
const app = "/api/account";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  domain: baseDomain,
  auth: {
    login: `${auth}/login`,
    logout: `${auth}/logout`,
    validateUsername: `${auth}/validate-username`,
    refreshToken: `${auth}/refreshToken`,
    register: `${auth}/signup`,
    self: auth,
  },
  app: {
    add: `${app}/add`,
    getAccounts: `${app}`,
    getPassword: `${app}`,
    self: app,
    update: `${app}/update`,
  },
  externalApi: {
    companies: `https://autocomplete.clearbit.com/v1/companies/suggest?query=`,
  },
};
